import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-command-bar',
  templateUrl: './command-bar.component.html',
  styleUrls: ['./command-bar.component.scss']
})
export class CommandBarComponent implements OnInit {
  constructor(private router: Router) { }

  ngOnInit(): void { }

  // TODO: Make these all just one listener?
  @HostListener('window:keyup.a', ['$event'])
  handleAddKey(evt: KeyboardEvent) {
    if (evt.target === document.body) {
      this.router.navigateByUrl('/add/current');
    }
  }

  @HostListener('window:keyup.b', ['$event'])
  handleBacklogKey(evt: KeyboardEvent) {
    if (evt.target === document.body) {
      this.router.navigateByUrl('/add/backlog');
    }
  }

  @HostListener('window:keyup.c', ['$event'])
  handleCurrentKey(evt: KeyboardEvent) {
    if (evt.target === document.body) {
      this.router.navigateByUrl('/current');
    }
  }

  @HostListener('window:keyup.s', ['$event'])
  handleSprintKey(evt: KeyboardEvent) {
    if (evt.target === document.body) {
      this.router.navigateByUrl('/sprints');
    }
  }
}
